import { useEffect, useState } from 'react';
import { SidebarItem } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/frontend-plugin-api';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import { useBackend } from '../useOrchestrator';
import type { LiveEnv, MyPullRequests } from './types';

/**
 * Sidebar entry of the ephemeral envs. A dot and the count show when the signed-in developer
 * has envs running.
 */
export function EphemeralEnvsSidebarItem() {
  const identityApi = useApi(identityApiRef);
  const [userRef, setUserRef] = useState<string>();
  useEffect(() => {
    identityApi
      .getBackstageIdentity()
      .then(identity => setUserRef(identity.userEntityRef));
  }, [identityApi]);

  const envs = useBackend<{ items: LiveEnv[] }>(
    'platform-orchestrator',
    '/ephemeral-envs',
    { refreshMs: 180_000 },
  );
  const prs = useBackend<MyPullRequests>(
    'platform-orchestrator',
    '/me/pull-requests',
    { refreshMs: 180_000 },
  );

  const login = prs.value?.login?.toLowerCase();
  const count = (envs.value?.items ?? []).filter(
    env =>
      (userRef && env.owner.userRef === userRef) ||
      (login && env.owner.githubLogin?.toLowerCase() === login),
  ).length;

  return (
    <SidebarItem
      icon={CloudQueueIcon}
      to="/ephemeral-envs"
      text={count > 0 ? `Environnements (${count})` : 'Environnements'}
      hasNotifications={count > 0}
    />
  );
}
